{
 "title": "BDayminton 2026",
 "date": "Sunday 18 October 2026",
 "numbers": {
  "games": 100,
  "points": 1755,
  "rounds": 25,
  "players": 32,
  "first": "13:40",
  "last": "17:36",
  "commonScore": "11-6",
  "commonCount": 17,
  "deuces": 9,
  "americano": 18,
  "mexicano": 7,
  "longest": {
   "line": "Sam & Yashvi 14-12 Aswini & Pooja S, round 18, court 4",
   "minutes": 9.6
  }
 },
 "podium": [
  "ani",
  "krish",
  "ashiv"
 ],
 "board": [
  "ani",
  "krish",
  "ashiv",
  "nayan",
  "raul",
  "riyan",
  "thujhan",
  "darshil",
  "piri",
  "khushal",
  "sam",
  "luke",
  "mihir",
  "thelaksan",
  "abhi",
  "pooja-s",
  "stan",
  "paddy",
  "dhiran",
  "devika",
  "chandni",
  "nikhil",
  "mayuran",
  "kedar",
  "shailen",
  "aswini",
  "barshan",
  "pooja-j",
  "steven",
  "yashvi",
  "deepali",
  "simmi"
 ],
 "awards": [
  {
   "title": "Best picker",
   "who": [
    "dhiran"
   ],
   "detail": "42 right picks"
  },
  {
   "title": "Most cursed",
   "who": [
    "krish",
    "nayan"
   ],
   "detail": "cursed 5 times"
  },
  {
   "title": "Giant killer",
   "who": [
    "ani",
    "nayan"
   ],
   "detail": "beat the top three 5 times"
  },
  {
   "title": "Loudest heckler",
   "who": [
    "ashiv",
    "dhiran",
    "mihir",
    "thujhan"
   ],
   "detail": "2 heckles"
  },
  {
   "title": "Biggest upset",
   "who": [
    "pooja-j",
    "nayan"
   ],
   "detail": "Pooja J & Nayan (ranked 26 and 19) beat Mayuran & Mihir (6 and 11), round 3"
  },
  {
   "title": "Closest game",
   "who": [
    "steven",
    "thelaksan",
    "nikhil",
    "thujhan"
   ],
   "detail": "Steven & Thelaksan 15-13 Nikhil & Thujhan, round 7"
  },
  {
   "title": "Iron legs",
   "who": [
    "darshil",
    "nikhil"
   ],
   "detail": "14 games, 252 points played"
  },
  {
   "title": "Biggest thrashing",
   "who": [
    "dhiran",
    "aswini",
    "raul"
   ],
   "detail": "Two games at 11-1, rounds 7 and 14"
  }
 ],
 "rounds": [
  {
   "no": 1,
   "mode": "americano",
   "at": "13:40",
   "games": [
    {
     "court": 1,
     "a": [
      "piri",
      "darshil"
     ],
     "b": [
      "simmi",
      "pooja-j"
     ],
     "sa": 11,
     "sb": 2
    },
    {
     "court": 2,
     "a": [
      "khushal",
      "mayuran"
     ],
     "b": [
      "thelaksan",
      "dhiran"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "nayan",
      "yashvi"
     ],
     "b": [
      "chandni",
      "luke"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "sam",
      "mihir"
     ],
     "b": [
      "ashiv",
      "shailen"
     ],
     "sa": 11,
     "sb": 8
    }
   ],
   "out": [
    "abhi",
    "aswini",
    "barshan",
    "deepali",
    "devika",
    "kedar",
    "krish",
    "nikhil",
    "paddy",
    "raul",
    "riyan",
    "steven",
    "thujhan"
   ]
  },
  {
   "no": 2,
   "mode": "americano",
   "at": "13:49",
   "games": [
    {
     "court": 1,
     "a": [
      "aswini",
      "chandni"
     ],
     "b": [
      "paddy",
      "riyan"
     ],
     "sa": 3,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "raul",
      "kedar"
     ],
     "b": [
      "sam",
      "deepali"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 3,
     "a": [
      "thujhan",
      "abhi"
     ],
     "b": [
      "barshan",
      "nikhil"
     ],
     "sa": 11,
     "sb": 7
    },
    {
     "court": 4,
     "a": [
      "krish",
      "shailen"
     ],
     "b": [
      "devika",
      "steven"
     ],
     "sa": 11,
     "sb": 2
    }
   ],
   "out": [
    "ashiv",
    "darshil",
    "dhiran",
    "khushal",
    "luke",
    "mayuran",
    "mihir",
    "nayan",
    "piri",
    "pooja-j",
    "simmi",
    "thelaksan",
    "yashvi"
   ]
  },
  {
   "no": 3,
   "mode": "americano",
   "at": "13:55",
   "games": [
    {
     "court": 1,
     "a": [
      "yashvi",
      "simmi"
     ],
     "b": [
      "ashiv",
      "raul"
     ],
     "sa": 4,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "luke",
      "piri"
     ],
     "b": [
      "khushal",
      "dhiran"
     ],
     "sa": 11,
     "sb": 7
    },
    {
     "court": 3,
     "a": [
      "darshil",
      "deepali"
     ],
     "b": [
      "thelaksan",
      "abhi"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "mayuran",
      "mihir"
     ],
     "b": [
      "pooja-j",
      "nayan"
     ],
     "sa": 9,
     "sb": 11
    }
   ],
   "out": [
    "aswini",
    "barshan",
    "chandni",
    "devika",
    "kedar",
    "krish",
    "nikhil",
    "paddy",
    "riyan",
    "sam",
    "shailen",
    "steven",
    "thujhan"
   ]
  },
  {
   "no": 4,
   "mode": "americano",
   "at": "14:01",
   "games": [
    {
     "court": 1,
     "a": [
      "paddy",
      "thujhan"
     ],
     "b": [
      "devika",
      "raul"
     ],
     "sa": 12,
     "sb": 14
    },
    {
     "court": 2,
     "a": [
      "shailen",
      "kedar"
     ],
     "b": [
      "krish",
      "barshan"
     ],
     "sa": 2,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "darshil",
      "chandni"
     ],
     "b": [
      "steven",
      "aswini"
     ],
     "sa": 11,
     "sb": 5
    },
    {
     "court": 4,
     "a": [
      "khushal",
      "nikhil"
     ],
     "b": [
      "sam",
      "riyan"
     ],
     "sa": 11,
     "sb": 8
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "deepali",
    "dhiran",
    "luke",
    "mayuran",
    "mihir",
    "nayan",
    "piri",
    "pooja-j",
    "simmi",
    "thelaksan",
    "yashvi"
   ]
  },
  {
   "no": 5,
   "mode": "americano",
   "at": "14:09",
   "games": [
    {
     "court": 1,
     "a": [
      "mayuran",
      "yashvi"
     ],
     "b": [
      "abhi",
      "piri"
     ],
     "sa": 2,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "riyan",
      "simmi"
     ],
     "b": [
      "krish",
      "thelaksan"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "luke",
      "nayan"
     ],
     "b": [
      "pooja-j",
      "nikhil"
     ],
     "sa": 11,
     "sb": 2
    },
    {
     "court": 4,
     "a": [
      "deepali",
      "dhiran"
     ],
     "b": [
      "ashiv",
      "mihir"
     ],
     "sa": 2,
     "sb": 11
    }
   ],
   "out": [
    "aswini",
    "barshan",
    "chandni",
    "darshil",
    "devika",
    "kedar",
    "khushal",
    "paddy",
    "raul",
    "sam",
    "shailen",
    "steven",
    "thujhan"
   ]
  },
  {
   "no": 6,
   "mode": "americano",
   "at": "14:17",
   "games": [
    {
     "court": 1,
     "a": [
      "piri",
      "kedar"
     ],
     "b": [
      "steven",
      "raul"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 2,
     "a": [
      "ashiv",
      "darshil"
     ],
     "b": [
      "khushal",
      "chandni"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "barshan",
      "devika"
     ],
     "b": [
      "aswini",
      "sam"
     ],
     "sa": 6,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "nayan",
      "thujhan"
     ],
     "b": [
      "shailen",
      "paddy"
     ],
     "sa": 11,
     "sb": 2
    }
   ],
   "out": [
    "abhi",
    "deepali",
    "dhiran",
    "krish",
    "luke",
    "mayuran",
    "nikhil",
    "pooja-j",
    "riyan",
    "simmi",
    "thelaksan",
    "yashvi"
   ]
  },
  {
   "no": 7,
   "mode": "americano",
   "at": "14:27",
   "games": [
    {
     "court": 1,
     "a": [
      "steven",
      "thelaksan"
     ],
     "b": [
      "nikhil",
      "thujhan"
     ],
     "sa": 15,
     "sb": 13
    },
    {
     "court": 2,
     "a": [
      "simmi",
      "mayuran"
     ],
     "b": [
      "yashvi",
      "riyan"
     ],
     "sa": 4,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "luke",
      "abhi"
     ],
     "b": [
      "krish",
      "devika"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "deepali",
      "pooja-j"
     ],
     "b": [
      "dhiran",
      "aswini"
     ],
     "sa": 1,
     "sb": 11
    }
   ],
   "out": [
    "ashiv",
    "barshan",
    "chandni",
    "darshil",
    "kedar",
    "khushal",
    "nayan",
    "paddy",
    "piri",
    "raul",
    "sam",
    "shailen"
   ]
  },
  {
   "no": 8,
   "mode": "americano",
   "at": "14:37",
   "games": [
    {
     "court": 1,
     "a": [
      "darshil",
      "raul"
     ],
     "b": [
      "dhiran",
      "mihir"
     ],
     "sa": 11,
     "sb": 7
    },
    {
     "court": 2,
     "a": [
      "barshan",
      "khushal"
     ],
     "b": [
      "chandni",
      "yashvi"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "kedar",
      "ashiv"
     ],
     "b": [
      "shailen",
      "devika"
     ],
     "sa": 11,
     "sb": 9
    },
    {
     "court": 4,
     "a": [
      "piri",
      "sam"
     ],
     "b": [
      "nayan",
      "paddy"
     ],
     "sa": 2,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "aswini",
    "deepali",
    "krish",
    "luke",
    "mayuran",
    "nikhil",
    "pooja-j",
    "riyan",
    "simmi",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 9,
   "mode": "americano",
   "at": "14:46",
   "games": [
    {
     "court": 1,
     "a": [
      "krish",
      "abhi"
     ],
     "b": [
      "thelaksan",
      "thujhan"
     ],
     "sa": 11,
     "sb": 5
    },
    {
     "court": 2,
     "a": [
      "luke",
      "deepali"
     ],
     "b": [
      "steven",
      "riyan"
     ],
     "sa": 9,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "nikhil",
      "raul"
     ],
     "b": [
      "mayuran",
      "pooja-j"
     ],
     "sa": 11,
     "sb": 4
    },
    {
     "court": 4,
     "a": [
      "piri",
      "paddy"
     ],
     "b": [
      "kedar",
      "barshan"
     ],
     "sa": 11,
     "sb": 2
    }
   ],
   "out": [
    "ashiv",
    "chandni",
    "darshil",
    "devika",
    "dhiran",
    "khushal",
    "mihir",
    "nayan",
    "sam",
    "shailen",
    "yashvi"
   ]
  },
  {
   "no": 10,
   "mode": "americano",
   "at": "14:54",
   "games": [
    {
     "court": 1,
     "a": [
      "luke",
      "riyan"
     ],
     "b": [
      "sam",
      "pooja-s"
     ],
     "sa": 11,
     "sb": 9
    },
    {
     "court": 2,
     "a": [
      "simmi",
      "khushal"
     ],
     "b": [
      "nayan",
      "aswini"
     ],
     "sa": 5,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "chandni",
      "devika"
     ],
     "b": [
      "pooja-j",
      "mihir"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 4,
     "a": [
      "yashvi",
      "shailen"
     ],
     "b": [
      "dhiran",
      "darshil"
     ],
     "sa": 7,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "barshan",
    "deepali",
    "kedar",
    "krish",
    "mayuran",
    "nikhil",
    "paddy",
    "piri",
    "raul",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 11,
   "mode": "americano",
   "at": "15:05",
   "games": [
    {
     "court": 1,
     "a": [
      "simmi",
      "barshan"
     ],
     "b": [
      "deepali",
      "steven"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 2,
     "a": [
      "thujhan",
      "krish"
     ],
     "b": [
      "piri",
      "mayuran"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "aswini",
      "kedar"
     ],
     "b": [
      "nikhil",
      "thelaksan"
     ],
     "sa": 6,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "pooja-s",
      "paddy"
     ],
     "b": [
      "abhi",
      "ashiv"
     ],
     "sa": 6,
     "sb": 11
    }
   ],
   "out": [
    "chandni",
    "darshil",
    "devika",
    "dhiran",
    "khushal",
    "luke",
    "mihir",
    "nayan",
    "pooja-j",
    "raul",
    "riyan",
    "sam",
    "shailen",
    "yashvi"
   ]
  },
  {
   "no": 12,
   "mode": "americano",
   "at": "15:13",
   "games": [
    {
     "court": 1,
     "a": [
      "pooja-s",
      "chandni"
     ],
     "b": [
      "dhiran",
      "shailen"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "raul",
      "yashvi"
     ],
     "b": [
      "nayan",
      "riyan"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "ani",
      "khushal"
     ],
     "b": [
      "pooja-j",
      "devika"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 4,
     "a": [
      "luke",
      "sam"
     ],
     "b": [
      "mihir",
      "darshil"
     ],
     "sa": 9,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "aswini",
    "barshan",
    "deepali",
    "kedar",
    "krish",
    "mayuran",
    "nikhil",
    "paddy",
    "piri",
    "simmi",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 13,
   "mode": "americano",
   "at": "15:23",
   "games": [
    {
     "court": 1,
     "a": [
      "luke",
      "kedar"
     ],
     "b": [
      "simmi",
      "abhi"
     ],
     "sa": 11,
     "sb": 4
    },
    {
     "court": 2,
     "a": [
      "krish",
      "nikhil"
     ],
     "b": [
      "barshan",
      "ani"
     ],
     "sa": 9,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "ashiv",
      "deepali"
     ],
     "b": [
      "mayuran",
      "thujhan"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "steven",
      "mihir"
     ],
     "b": [
      "thelaksan",
      "paddy"
     ],
     "sa": 4,
     "sb": 11
    }
   ],
   "out": [
    "chandni",
    "darshil",
    "devika",
    "dhiran",
    "khushal",
    "nayan",
    "piri",
    "pooja-j",
    "pooja-s",
    "raul",
    "riyan",
    "sam",
    "shailen",
    "yashvi"
   ]
  },
  {
   "no": 14,
   "mode": "americano",
   "at": "15:30",
   "games": [
    {
     "court": 1,
     "a": [
      "riyan",
      "khushal"
     ],
     "b": [
      "ani",
      "shailen"
     ],
     "sa": 9,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "pooja-j",
      "sam"
     ],
     "b": [
      "yashvi",
      "pooja-s"
     ],
     "sa": 11,
     "sb": 5
    },
    {
     "court": 3,
     "a": [
      "aswini",
      "stan"
     ],
     "b": [
      "raul",
      "dhiran"
     ],
     "sa": 1,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "darshil",
      "devika"
     ],
     "b": [
      "nayan",
      "piri"
     ],
     "sa": 5,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "barshan",
    "chandni",
    "deepali",
    "kedar",
    "krish",
    "luke",
    "mayuran",
    "nikhil",
    "paddy",
    "simmi",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 15,
   "mode": "americano",
   "at": "15:38",
   "games": [
    {
     "court": 1,
     "a": [
      "chandni",
      "shailen"
     ],
     "b": [
      "abhi",
      "deepali"
     ],
     "sa": 10,
     "sb": 12
    },
    {
     "court": 2,
     "a": [
      "krish",
      "simmi"
     ],
     "b": [
      "dhiran",
      "nikhil"
     ],
     "sa": 11,
     "sb": 9
    },
    {
     "court": 3,
     "a": [
      "thujhan",
      "steven"
     ],
     "b": [
      "riyan",
      "stan"
     ],
     "sa": 3,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "thelaksan",
      "barshan"
     ],
     "b": [
      "luke",
      "ashiv"
     ],
     "sa": 2,
     "sb": 11
    }
   ],
   "out": [
    "ani",
    "aswini",
    "darshil",
    "devika",
    "khushal",
    "nayan",
    "piri",
    "pooja-j",
    "pooja-s",
    "raul",
    "sam",
    "yashvi"
   ]
  },
  {
   "no": 16,
   "mode": "americano",
   "at": "15:46",
   "games": [
    {
     "court": 1,
     "a": [
      "stan",
      "sam"
     ],
     "b": [
      "piri",
      "pooja-j"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 2,
     "a": [
      "yashvi",
      "aswini"
     ],
     "b": [
      "ani",
      "kedar"
     ],
     "sa": 9,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "devika",
      "nayan"
     ],
     "b": [
      "barshan",
      "pooja-s"
     ],
     "sa": 11,
     "sb": 4
    },
    {
     "court": 4,
     "a": [
      "darshil",
      "khushal"
     ],
     "b": [
      "paddy",
      "raul"
     ],
     "sa": 11,
     "sb": 8
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "chandni",
    "deepali",
    "dhiran",
    "krish",
    "luke",
    "nikhil",
    "riyan",
    "shailen",
    "simmi",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 17,
   "mode": "americano",
   "at": "15:54",
   "games": [
    {
     "court": 1,
     "a": [
      "dhiran",
      "steven"
     ],
     "b": [
      "kedar",
      "abhi"
     ],
     "sa": 11,
     "sb": 9
    },
    {
     "court": 2,
     "a": [
      "simmi",
      "luke"
     ],
     "b": [
      "chandni",
      "thujhan"
     ],
     "sa": 11,
     "sb": 7
    },
    {
     "court": 3,
     "a": [
      "riyan",
      "nikhil"
     ],
     "b": [
      "ashiv",
      "paddy"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "thelaksan",
      "deepali"
     ],
     "b": [
      "krish",
      "piri"
     ],
     "sa": 4,
     "sb": 11
    }
   ],
   "out": [
    "ani",
    "aswini",
    "barshan",
    "darshil",
    "devika",
    "khushal",
    "nayan",
    "pooja-j",
    "pooja-s",
    "raul",
    "sam",
    "stan",
    "yashvi"
   ]
  },
  {
   "no": 18,
   "mode": "americano",
   "at": "16:04",
   "games": [
    {
     "court": 1,
     "a": [
      "khushal",
      "devika"
     ],
     "b": [
      "deepali",
      "nikhil"
     ],
     "sa": 11,
     "sb": 2
    },
    {
     "court": 2,
     "a": [
      "raul",
      "pooja-j"
     ],
     "b": [
      "barshan",
      "shailen"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "nayan",
      "darshil"
     ],
     "b": [
      "stan",
      "ani"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 4,
     "a": [
      "sam",
      "yashvi"
     ],
     "b": [
      "aswini",
      "pooja-s"
     ],
     "sa": 14,
     "sb": 12
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "chandni",
    "dhiran",
    "kedar",
    "krish",
    "luke",
    "paddy",
    "piri",
    "riyan",
    "simmi",
    "steven",
    "thelaksan",
    "thujhan"
   ]
  },
  {
   "no": 19,
   "mode": "mexicano",
   "at": "16:39",
   "games": [
    {
     "court": 1,
     "a": [
      "krish",
      "ashiv"
     ],
     "b": [
      "luke",
      "darshil"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 2,
     "a": [
      "riyan",
      "abhi"
     ],
     "b": [
      "thujhan",
      "piri"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "paddy",
      "kedar"
     ],
     "b": [
      "mihir",
      "thelaksan"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "nikhil",
      "simmi"
     ],
     "b": [
      "steven",
      "mayuran"
     ],
     "sa": 6,
     "sb": 11
    }
   ],
   "out": [
    "ani",
    "barshan",
    "deepali",
    "devika",
    "khushal",
    "nayan",
    "pooja-j",
    "pooja-s",
    "raul",
    "sam",
    "shailen",
    "stan",
    "yashvi"
   ]
  },
  {
   "no": 20,
   "mode": "mexicano",
   "at": "16:47",
   "games": [
    {
     "court": 1,
     "a": [
      "nayan",
      "raul"
     ],
     "b": [
      "ani",
      "thujhan"
     ],
     "sa": 6,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "sam",
      "devika"
     ],
     "b": [
      "khushal",
      "thelaksan"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "chandni",
      "stan"
     ],
     "b": [
      "shailen",
      "pooja-s"
     ],
     "sa": 10,
     "sb": 12
    },
    {
     "court": 4,
     "a": [
      "yashvi",
      "deepali"
     ],
     "b": [
      "barshan",
      "pooja-j"
     ],
     "sa": 5,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "darshil",
    "kedar",
    "krish",
    "luke",
    "mayuran",
    "mihir",
    "nikhil",
    "paddy",
    "piri",
    "riyan",
    "simmi",
    "steven"
   ]
  },
  {
   "no": 21,
   "mode": "mexicano",
   "at": "16:56",
   "games": [
    {
     "court": 1,
     "a": [
      "krish",
      "darshil"
     ],
     "b": [
      "ashiv",
      "riyan"
     ],
     "sa": 11,
     "sb": 13
    },
    {
     "court": 2,
     "a": [
      "sam",
      "paddy"
     ],
     "b": [
      "dhiran",
      "abhi"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 3,
     "a": [
      "chandni",
      "piri"
     ],
     "b": [
      "kedar",
      "mihir"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 4,
     "a": [
      "nikhil",
      "mayuran"
     ],
     "b": [
      "steven",
      "simmi"
     ],
     "sa": 11,
     "sb": 2
    }
   ],
   "out": [
    "ani",
    "barshan",
    "deepali",
    "devika",
    "khushal",
    "luke",
    "nayan",
    "pooja-j",
    "pooja-s",
    "raul",
    "shailen",
    "stan",
    "thelaksan",
    "thujhan",
    "yashvi"
   ]
  },
  {
   "no": 22,
   "mode": "mexicano",
   "at": "17:07",
   "games": [
    {
     "court": 1,
     "a": [
      "krish",
      "luke"
     ],
     "b": [
      "ani",
      "nayan"
     ],
     "sa": 10,
     "sb": 12
    },
    {
     "court": 2,
     "a": [
      "thujhan",
      "pooja-j"
     ],
     "b": [
      "raul",
      "deepali"
     ],
     "sa": 10,
     "sb": 12
    },
    {
     "court": 3,
     "a": [
      "shailen",
      "khushal"
     ],
     "b": [
      "thelaksan",
      "stan"
     ],
     "sa": 9,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "pooja-s",
      "steven"
     ],
     "b": [
      "yashvi",
      "barshan"
     ],
     "sa": 11,
     "sb": 7
    }
   ],
   "out": [
    "abhi",
    "ashiv",
    "chandni",
    "darshil",
    "devika",
    "dhiran",
    "mayuran",
    "mihir",
    "nikhil",
    "paddy",
    "piri",
    "riyan",
    "sam"
   ]
  },
  {
   "no": 23,
   "mode": "mexicano",
   "at": "17:13",
   "games": [
    {
     "court": 1,
     "a": [
      "paddy",
      "luke"
     ],
     "b": [
      "piri",
      "riyan"
     ],
     "sa": 2,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "darshil",
      "abhi"
     ],
     "b": [
      "mihir",
      "devika"
     ],
     "sa": 5,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "chandni",
      "nikhil"
     ],
     "b": [
      "dhiran",
      "kedar"
     ],
     "sa": 11,
     "sb": 13
    },
    {
     "court": 4,
     "a": [
      "mayuran",
      "barshan"
     ],
     "b": [
      "aswini",
      "simmi"
     ],
     "sa": 11,
     "sb": 6
    }
   ],
   "out": [
    "ani",
    "deepali",
    "khushal",
    "krish",
    "nayan",
    "pooja-j",
    "pooja-s",
    "raul",
    "sam",
    "shailen",
    "stan",
    "steven",
    "thelaksan",
    "thujhan",
    "yashvi"
   ]
  },
  {
   "no": 24,
   "mode": "mexicano",
   "at": "17:21",
   "games": [
    {
     "court": 1,
     "a": [
      "krish",
      "nayan"
     ],
     "b": [
      "ani",
      "raul"
     ],
     "sa": 8,
     "sb": 11
    },
    {
     "court": 2,
     "a": [
      "thujhan",
      "khushal"
     ],
     "b": [
      "sam",
      "thelaksan"
     ],
     "sa": 11,
     "sb": 9
    },
    {
     "court": 3,
     "a": [
      "deepali",
      "chandni"
     ],
     "b": [
      "abhi",
      "yashvi"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 4,
     "a": [
      "steven",
      "stan"
     ],
     "b": [
      "pooja-j",
      "pooja-s"
     ],
     "sa": 8,
     "sb": 11
    }
   ],
   "out": [
    "aswini",
    "barshan",
    "darshil",
    "devika",
    "dhiran",
    "kedar",
    "luke",
    "mayuran",
    "mihir",
    "nikhil",
    "paddy",
    "piri",
    "riyan",
    "shailen",
    "simmi"
   ]
  },
  {
   "no": 25,
   "mode": "mexicano",
   "at": "17:30",
   "games": [
    {
     "court": 1,
     "a": [
      "ani",
      "darshil"
     ],
     "b": [
      "ashiv",
      "piri"
     ],
     "sa": 11,
     "sb": 8
    },
    {
     "court": 2,
     "a": [
      "luke",
      "devika"
     ],
     "b": [
      "mihir",
      "paddy"
     ],
     "sa": 7,
     "sb": 11
    },
    {
     "court": 3,
     "a": [
      "pooja-s",
      "stan"
     ],
     "b": [
      "nikhil",
      "kedar"
     ],
     "sa": 11,
     "sb": 6
    },
    {
     "court": 4,
     "a": [
      "shailen",
      "simmi"
     ],
     "b": [
      "mayuran",
      "aswini"
     ],
     "sa": 5,
     "sb": 11
    }
   ],
   "out": [
    "abhi",
    "barshan",
    "chandni",
    "deepali",
    "khushal",
    "krish",
    "nayan",
    "pooja-j",
    "raul",
    "riyan",
    "sam",
    "steven",
    "thelaksan",
    "thujhan",
    "yashvi"
   ]
  }
 ],
 "people": {
  "abhi": {
   "name": "Abhi",
   "photo": 1,
   "place": 15,
   "ranked": true,
   "games": 13,
   "wins": 7,
   "losses": 6,
   "pointsFor": 117,
   "pointsAgainst": 110,
   "avg": 9,
   "diff": 7,
   "bestRun": 3,
   "peopleMet": 24,
   "court": 1,
   "wall": [],
   "titles": [
    {
     "title": "Signature Win",
     "line": "Beat Mayuran & Yashvi 11-2 with Piri in round 5",
     "where": null
    },
    {
     "title": "Hot Hand",
     "line": "3 wins in a row",
     "where": null
    }
   ],
   "nemesis": {
    "id": "devika",
    "lost": 2
   },
   "bestWin": {
    "round": 5,
    "court": 1
   }
  },
  "ani": {
   "name": "Ani",
   "photo": 1,
   "place": 1,
   "ranked": true,
   "games": 9,
   "wins": 8,
   "losses": 1,
   "pointsFor": 97,
   "pointsAgainst": 76,
   "avg": 10.78,
   "diff": 21,
   "bestRun": 4,
   "peopleMet": 19,
   "court": 1,
   "wall": [
    "Giant killer"
   ],
   "titles": [
    {
     "title": "Just Enough",
     "line": "Won 4 games by exactly two",
     "where": "top on the day"
    },
    {
     "title": "Mexicano Master",
     "line": "4 wins from 4 Mexicano games",
     "where": "joint top on the day"
    },
    {
     "title": "Wanted Poster",
     "line": "Played 7 rounds with a bounty on their head",
     "where": "2nd on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 12,
    "court": 3
   }
  },
  "ashiv": {
   "name": "Ashiv",
   "photo": 2,
   "place": 3,
   "ranked": true,
   "games": 12,
   "wins": 9,
   "losses": 3,
   "pointsFor": 125,
   "pointsAgainst": 88,
   "avg": 10.42,
   "diff": 37,
   "bestRun": 5,
   "peopleMet": 26,
   "court": 1,
   "wall": [
    "Loudest heckler"
   ],
   "titles": [
    {
     "title": "The Reverse Oracle",
     "line": "14 wrong picks. Bet against this one",
     "where": "top on the day"
    },
    {
     "title": "Express Delivery",
     "line": "Won 11-2 in 3.6 minutes, round 5",
     "where": "joint top on the day"
    },
    {
     "title": "Professional Spectator",
     "line": "50 picks made from the bench",
     "where": "2nd on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 5,
    "court": 4
   }
  },
  "aswini": {
   "name": "Aswini",
   "photo": 1,
   "place": 26,
   "ranked": true,
   "games": 11,
   "wins": 4,
   "losses": 7,
   "pointsFor": 86,
   "pointsAgainst": 97,
   "avg": 7.82,
   "diff": -11,
   "bestRun": 3,
   "peopleMet": 24,
   "court": 3,
   "wall": [
    "Biggest thrashing"
   ],
   "titles": [
    {
     "title": "The Bulldozer",
     "line": "Won by 10: Dhiran & Aswini 11-1 Deepali & Pooja J, round 7",
     "where": "joint top on the day"
    },
    {
     "title": "Rollercoaster",
     "line": "From winning by 10 to losing by 10",
     "where": "top on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 7,
    "court": 4
   }
  },
  "barshan": {
   "name": "Barshan",
   "photo": 1,
   "place": 27,
   "ranked": true,
   "games": 13,
   "wins": 6,
   "losses": 7,
   "pointsFor": 100,
   "pointsAgainst": 111,
   "avg": 7.69,
   "diff": -11,
   "bestRun": 2,
   "peopleMet": 26,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Quick Turnaround",
     "line": "5.3 minutes a game on average",
     "where": "2nd on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Shailen & Kedar 11-2 with Krish in round 4",
     "where": null
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 4,
    "court": 2
   }
  },
  "chandni": {
   "name": "Chandni",
   "photo": 3,
   "place": 21,
   "ranked": true,
   "games": 13,
   "wins": 4,
   "losses": 9,
   "pointsFor": 112,
   "pointsAgainst": 129,
   "avg": 8.62,
   "diff": -17,
   "bestRun": 1,
   "peopleMet": 25,
   "court": 3,
   "wall": [],
   "titles": [
    {
     "title": "Deuce Heartbreak",
     "line": "Lost 3 games at deuce",
     "where": "joint top on the day"
    },
    {
     "title": "Deuce Merchant",
     "line": "3 games that went to deuce",
     "where": "joint top on the day"
    }
   ],
   "nemesis": {
    "id": "abhi",
    "lost": 2
   },
   "bestWin": {
    "round": 4,
    "court": 3
   }
  },
  "darshil": {
   "name": "Darshil",
   "photo": 1,
   "place": 8,
   "ranked": true,
   "games": 14,
   "wins": 9,
   "losses": 5,
   "pointsFor": 135,
   "pointsAgainst": 117,
   "avg": 9.64,
   "diff": 18,
   "bestRun": 5,
   "peopleMet": 25,
   "court": 1,
   "wall": [
    "Iron legs"
   ],
   "titles": [
    {
     "title": "Marathon Legs",
     "line": "252 points played through",
     "where": "joint top on the day"
    },
    {
     "title": "Americano Ace",
     "line": "8 wins from 10 Americano games",
     "where": "3rd on the day, joint"
    },
    {
     "title": "Points Machine",
     "line": "135 points in 14 games",
     "where": "2nd on the day"
    }
   ],
   "nemesis": {
    "id": "ashiv",
    "lost": 2
   },
   "bestWin": {
    "round": 1,
    "court": 1
   }
  },
  "deepali": {
   "name": "Deepali",
   "photo": 1,
   "place": 31,
   "ranked": true,
   "games": 13,
   "wins": 2,
   "losses": 11,
   "pointsFor": 83,
   "pointsAgainst": 141,
   "avg": 6.38,
   "diff": -58,
   "bestRun": 1,
   "peopleMet": 26,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Ice in the Veins",
     "line": "Won 2 of 2 deuce games",
     "where": "joint top on the day"
    },
    {
     "title": "Took One for the Team",
     "line": "3 heavy defeats, taken with dignity",
     "where": "joint top on the day"
    },
    {
     "title": "The Grand Tour",
     "line": "Played every court: 3, 3, 3, 4 games on courts 1, 2, 3, 4",
     "where": "top on the day"
    }
   ],
   "nemesis": {
    "id": "abhi",
    "lost": 2
   },
   "bestWin": {
    "round": 15,
    "court": 1
   }
  },
  "devika": {
   "name": "Devika",
   "photo": 1,
   "place": 20,
   "ranked": true,
   "games": 13,
   "wins": 6,
   "losses": 7,
   "pointsFor": 112,
   "pointsAgainst": 115,
   "avg": 8.62,
   "diff": -3,
   "bestRun": 2,
   "peopleMet": 25,
   "court": 3,
   "wall": [],
   "titles": [
    {
     "title": "Proved Them Wrong",
     "line": "Won 4 games the hall said they would lose",
     "where": "top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Deepali & Nikhil 11-2 with Khushal in round 18",
     "where": null
    }
   ],
   "nemesis": {
    "id": "khushal",
    "lost": 2
   },
   "bestWin": {
    "round": 18,
    "court": 1
   }
  },
  "dhiran": {
   "name": "Dhiran",
   "photo": 1,
   "place": 19,
   "ranked": true,
   "games": 12,
   "wins": 6,
   "losses": 6,
   "pointsFor": 105,
   "pointsAgainst": 103,
   "avg": 8.75,
   "diff": 2,
   "bestRun": 3,
   "peopleMet": 25,
   "court": 2,
   "wall": [
    "Best picker",
    "Loudest heckler",
    "Biggest thrashing"
   ],
   "titles": [
    {
     "title": "The Contrarian",
     "line": "Went against the hall 13 times",
     "where": "top on the day"
    },
    {
     "title": "The Oracle",
     "line": "42 right picks from 52",
     "where": "top on the day"
    },
    {
     "title": "Number One Fan",
     "line": "Backed Thujhan 8 times",
     "where": "2nd on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 7,
    "court": 4
   }
  },
  "kedar": {
   "name": "Kedar",
   "photo": 1,
   "place": 24,
   "ranked": true,
   "games": 13,
   "wins": 6,
   "losses": 7,
   "pointsFor": 107,
   "pointsAgainst": 124,
   "avg": 8.23,
   "diff": -17,
   "bestRun": 2,
   "peopleMet": 24,
   "court": 3,
   "wall": [],
   "titles": [
    {
     "title": "Signature Win",
     "line": "Beat Simmi & Abhi 11-4 with Luke in round 13",
     "where": null
    },
    {
     "title": "Hot Hand",
     "line": "2 wins in a row",
     "where": null
    }
   ],
   "nemesis": {
    "id": "piri",
    "lost": 2
   },
   "bestWin": {
    "round": 13,
    "court": 1
   }
  },
  "khushal": {
   "name": "Khushal",
   "photo": 1,
   "place": 10,
   "ranked": true,
   "games": 13,
   "wins": 8,
   "losses": 5,
   "pointsFor": 124,
   "pointsAgainst": 108,
   "avg": 9.54,
   "diff": 16,
   "bestRun": 3,
   "peopleMet": 25,
   "court": 2,
   "wall": [],
   "titles": [
    {
     "title": "The Hex",
     "line": "Cursed Shailen & Simmi with Solo in round 25; they lost by 6",
     "where": "top on the day"
    },
    {
     "title": "Curse Proof",
     "line": "Won 3 of 3 cursed games",
     "where": "joint top on the day"
    },
    {
     "title": "Heckle Magnet",
     "line": "On the receiving end of 3 heckles",
     "where": "top on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 18,
    "court": 1
   }
  },
  "krish": {
   "name": "Krish",
   "photo": 1,
   "place": 2,
   "ranked": true,
   "games": 13,
   "wins": 9,
   "losses": 4,
   "pointsFor": 137,
   "pointsAgainst": 97,
   "avg": 10.54,
   "diff": 40,
   "bestRun": 6,
   "peopleMet": 21,
   "court": 1,
   "wall": [
    "Most cursed"
   ],
   "titles": [
    {
     "title": "King of the Hill",
     "line": "Led the podium race after 15 rounds",
     "where": "top on the day"
    },
    {
     "title": "Unbothered",
     "line": "Won 7 of 11 games with a bounty on their head",
     "where": "top on the day"
    },
    {
     "title": "Podium Regular",
     "line": "In the podium places after 17 rounds",
     "where": "top on the day"
    }
   ],
   "nemesis": {
    "id": "ani",
    "lost": 3
   },
   "bestWin": {
    "round": 2,
    "court": 4
   }
  },
  "luke": {
   "name": "Luke",
   "photo": 1,
   "place": 12,
   "ranked": true,
   "games": 14,
   "wins": 7,
   "losses": 7,
   "pointsFor": 129,
   "pointsAgainst": 116,
   "avg": 9.21,
   "diff": 13,
   "bestRun": 3,
   "peopleMet": 26,
   "court": 1,
   "wall": [],
   "titles": [
    {
     "title": "Tough Draw",
     "line": "Opponents placed 13.9 on average on the final board",
     "where": "2nd on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Pooja J & Nikhil 11-2 with Nayan in round 5",
     "where": null
    }
   ],
   "nemesis": {
    "id": "krish",
    "lost": 2
   },
   "bestWin": {
    "round": 5,
    "court": 3
   }
  },
  "mayuran": {
   "name": "Mayuran",
   "photo": 2,
   "place": 23,
   "ranked": true,
   "games": 11,
   "wins": 6,
   "losses": 5,
   "pointsFor": 91,
   "pointsAgainst": 88,
   "avg": 8.27,
   "diff": 3,
   "bestRun": 5,
   "peopleMet": 21,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Late Bloomer",
     "line": "1 win in their first 5 games, 5 in their last 5",
     "where": "joint top on the day"
    },
    {
     "title": "Most Improved",
     "line": "Up 4.3 points a game in Mexicano, from 6.7 to 11",
     "where": "top on the day"
    },
    {
     "title": "Strong Finish",
     "line": "Won 4 of their last four games",
     "where": "joint top on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 21,
    "court": 4
   }
  },
  "mihir": {
   "name": "Mihir",
   "photo": 1,
   "place": 13,
   "ranked": true,
   "games": 11,
   "wins": 6,
   "losses": 5,
   "pointsFor": 100,
   "pointsAgainst": 94,
   "avg": 9.09,
   "diff": 6,
   "bestRun": 2,
   "peopleMet": 19,
   "court": 4,
   "wall": [
    "Loudest heckler"
   ],
   "titles": [
    {
     "title": "Signature Win",
     "line": "Beat Deepali & Dhiran 11-2 with Ashiv in round 5",
     "where": null
    },
    {
     "title": "Hot Hand",
     "line": "2 wins in a row",
     "where": null
    }
   ],
   "nemesis": {
    "id": "chandni",
    "lost": 2
   },
   "bestWin": {
    "round": 5,
    "court": 4
   }
  },
  "nayan": {
   "name": "Nayan",
   "photo": 1,
   "place": 4,
   "ranked": true,
   "games": 13,
   "wins": 10,
   "losses": 3,
   "pointsFor": 132,
   "pointsAgainst": 87,
   "avg": 10.15,
   "diff": 45,
   "bestRun": 9,
   "peopleMet": 24,
   "court": 3,
   "wall": [
    "Most cursed",
    "Giant killer",
    "Biggest upset"
   ],
   "titles": [
    {
     "title": "Bounty Hunter",
     "line": "Beat a top-three player 5 times for a bounty",
     "where": "joint top on the day"
    },
    {
     "title": "Most Cursed",
     "line": "Cursed 5 times",
     "where": "joint top on the day"
    },
    {
     "title": "Plays Well With Others",
     "line": "Won with 10 different partners",
     "where": "joint top on the day"
    }
   ],
   "nemesis": {
    "id": "ani",
    "lost": 2
   },
   "bestWin": {
    "round": 5,
    "court": 3
   }
  },
  "nikhil": {
   "name": "Nikhil",
   "photo": 1,
   "place": 22,
   "ranked": true,
   "games": 14,
   "wins": 4,
   "losses": 10,
   "pointsFor": 116,
   "pointsAgainst": 136,
   "avg": 8.29,
   "diff": -20,
   "bestRun": 2,
   "peopleMet": 26,
   "court": 3,
   "wall": [
    "Closest game",
    "Iron legs"
   ],
   "titles": [
    {
     "title": "So Close",
     "line": "Lost 4 games by just two points",
     "where": "top on the day"
    },
    {
     "title": "Court 3 Local",
     "line": "7 of 14 games on court 3",
     "where": "joint top on the day"
    }
   ],
   "nemesis": {
    "id": "steven",
    "lost": 2
   },
   "bestWin": {
    "round": 21,
    "court": 4
   }
  },
  "paddy": {
   "name": "Paddy",
   "photo": 1,
   "place": 18,
   "ranked": true,
   "games": 13,
   "wins": 7,
   "losses": 6,
   "pointsFor": 115,
   "pointsAgainst": 100,
   "avg": 8.85,
   "diff": 15,
   "bestRun": 2,
   "peopleMet": 23,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Sharp Eye",
     "line": "83% of picks right, 30 of 36",
     "where": "top on the day"
    },
    {
     "title": "On a Roll",
     "line": "19 right picks in a row",
     "where": "top on the day"
    },
    {
     "title": "Friends in High Places",
     "line": "Partners placed 11.5 on average on the final board",
     "where": "top on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 8,
    "court": 4
   }
  },
  "piri": {
   "name": "Piri",
   "photo": 1,
   "place": 9,
   "ranked": true,
   "games": 14,
   "wins": 10,
   "losses": 4,
   "pointsFor": 134,
   "pointsAgainst": 88,
   "avg": 9.57,
   "diff": 46,
   "bestRun": 4,
   "peopleMet": 27,
   "court": 1,
   "wall": [],
   "titles": [
    {
     "title": "Margin Merchant",
     "line": "Plus 46 on points difference",
     "where": "top on the day"
    },
    {
     "title": "Naming Rights",
     "line": "4 wins by 8 or more",
     "where": "top on the day"
    },
    {
     "title": "Fast Starter",
     "line": "Won 4 of their first four games",
     "where": "joint top on the day"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 1,
    "court": 1
   }
  },
  "pooja-j": {
   "name": "Pooja J",
   "photo": 1,
   "place": 28,
   "ranked": true,
   "games": 13,
   "wins": 5,
   "losses": 8,
   "pointsFor": 96,
   "pointsAgainst": 122,
   "avg": 7.38,
   "diff": -26,
   "bestRun": 2,
   "peopleMet": 24,
   "court": 3,
   "wall": [
    "Biggest upset"
   ],
   "titles": [
    {
     "title": "Signature Win",
     "line": "Beat Yashvi & Pooja S 11-5 with Sam in round 14",
     "where": null
    },
    {
     "title": "Hot Hand",
     "line": "2 wins in a row",
     "where": null
    }
   ],
   "nemesis": {
    "id": "raul",
    "lost": 2
   },
   "bestWin": {
    "round": 14,
    "court": 2
   }
  },
  "pooja-s": {
   "name": "Pooja S",
   "photo": 1,
   "place": 16,
   "ranked": true,
   "games": 10,
   "wins": 4,
   "losses": 6,
   "pointsFor": 89,
   "pointsAgainst": 100,
   "avg": 8.9,
   "diff": -11,
   "bestRun": 4,
   "peopleMet": 19,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Mexicano Climber",
     "line": "Up 9 places in Mexicano, 25th to 16th",
     "where": "top on the day"
    },
    {
     "title": "Late Charge",
     "line": "Up 8 places after round 20, 24th to 16th",
     "where": "top on the day"
    },
    {
     "title": "Character Building",
     "line": "6 losses in a row, and back for more",
     "where": "2nd on the day"
    }
   ],
   "nemesis": {
    "id": "sam",
    "lost": 2
   },
   "bestWin": {
    "round": 25,
    "court": 3
   }
  },
  "raul": {
   "name": "Raul",
   "photo": 1,
   "place": 5,
   "ranked": true,
   "games": 13,
   "wins": 9,
   "losses": 4,
   "pointsFor": 130,
   "pointsAgainst": 104,
   "avg": 10,
   "diff": 26,
   "bestRun": 3,
   "peopleMet": 26,
   "court": 1,
   "wall": [
    "Biggest thrashing"
   ],
   "titles": [
    {
     "title": "Court 1 Resident",
     "line": "6 of 13 games on court 1",
     "where": "joint top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Aswini & Stan 11-1 with Dhiran in round 14",
     "where": null
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 14,
    "court": 3
   }
  },
  "riyan": {
   "name": "Riyan",
   "photo": 1,
   "place": 6,
   "ranked": true,
   "games": 13,
   "wins": 8,
   "losses": 5,
   "pointsFor": 129,
   "pointsAgainst": 103,
   "avg": 9.92,
   "diff": 26,
   "bestRun": 4,
   "peopleMet": 25,
   "court": 1,
   "wall": [],
   "titles": [
    {
     "title": "Crowd Favourite",
     "line": "The hall backed them in 10 games",
     "where": "joint top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Paddy & Luke 11-2 with Piri in round 23",
     "where": null
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 23,
    "court": 1
   }
  },
  "sam": {
   "name": "Sam",
   "photo": 1,
   "place": 11,
   "ranked": true,
   "games": 13,
   "wins": 6,
   "losses": 7,
   "pointsFor": 122,
   "pointsAgainst": 122,
   "avg": 9.38,
   "diff": 0,
   "bestRun": 3,
   "peopleMet": 25,
   "court": 2,
   "wall": [],
   "titles": [
    {
     "title": "Iron Lungs",
     "line": "91 minutes on court",
     "where": "top on the day"
    },
    {
     "title": "Takes Their Time",
     "line": "7 minutes a game on average",
     "where": "top on the day"
    }
   ],
   "nemesis": {
    "id": "khushal",
    "lost": 3
   },
   "bestWin": {
    "round": 14,
    "court": 2
   }
  },
  "shailen": {
   "name": "Shailen",
   "photo": 1,
   "place": 25,
   "ranked": true,
   "games": 13,
   "wins": 4,
   "losses": 9,
   "pointsFor": 103,
   "pointsAgainst": 129,
   "avg": 7.92,
   "diff": -26,
   "bestRun": 2,
   "peopleMet": 28,
   "court": 4,
   "wall": [],
   "titles": [
    {
     "title": "Punching Up",
     "line": "Beat a higher-placed pair 3 times",
     "where": "top on the day"
    },
    {
     "title": "Knows Everyone",
     "line": "Shared a court with 28 different people",
     "where": "top on the day"
    },
    {
     "title": "Seen Them All",
     "line": "Faced 24 different opponents",
     "where": "2nd on the day, joint"
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 2,
    "court": 4
   }
  },
  "simmi": {
   "name": "Simmi",
   "photo": 1,
   "place": 32,
   "ranked": true,
   "games": 13,
   "wins": 3,
   "losses": 10,
   "pointsFor": 78,
   "pointsAgainst": 132,
   "avg": 6,
   "diff": -54,
   "bestRun": 2,
   "peopleMet": 24,
   "court": 2,
   "wall": [],
   "titles": [
    {
     "title": "Has a Nemesis",
     "line": "Lost to Mayuran 4 times",
     "where": "top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Deepali & Steven 11-6 with Barshan in round 11",
     "where": null
    }
   ],
   "nemesis": {
    "id": "mayuran",
    "lost": 4
   },
   "bestWin": {
    "round": 11,
    "court": 1
   }
  },
  "stan": {
   "name": "Stan",
   "photo": 1,
   "place": 17,
   "ranked": true,
   "games": 8,
   "wins": 4,
   "losses": 4,
   "pointsFor": 71,
   "pointsAgainst": 71,
   "avg": 8.88,
   "diff": 0,
   "bestRun": 2,
   "peopleMet": 19,
   "court": 3,
   "wall": [],
   "titles": [
    {
     "title": "Fashionably Late",
     "line": "First game in round 14",
     "where": "top on the day"
    },
    {
     "title": "Creature of Habit",
     "line": "6 of 8 games on court 3",
     "where": "top on the day"
    }
   ],
   "nemesis": {
    "id": "pooja-s",
    "lost": 2
   },
   "bestWin": {
    "round": 15,
    "court": 3
   }
  },
  "steven": {
   "name": "Steven",
   "photo": 1,
   "place": 29,
   "ranked": true,
   "games": 13,
   "wins": 5,
   "losses": 8,
   "pointsFor": 95,
   "pointsAgainst": 132,
   "avg": 7.31,
   "diff": -37,
   "bestRun": 2,
   "peopleMet": 26,
   "court": 4,
   "wall": [
    "Closest game"
   ],
   "titles": [
    {
     "title": "Court 4 Landlord",
     "line": "6 of 13 games on court 4",
     "where": "joint top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Nikhil & Simmi 11-6 with Mayuran in round 19",
     "where": null
    }
   ],
   "nemesis": null,
   "bestWin": {
    "round": 19,
    "court": 4
   }
  },
  "thelaksan": {
   "name": "Thelaksan",
   "photo": 1,
   "place": 14,
   "ranked": true,
   "games": 13,
   "wins": 8,
   "losses": 5,
   "pointsFor": 118,
   "pointsAgainst": 117,
   "avg": 9.08,
   "diff": 1,
   "bestRun": 3,
   "peopleMet": 24,
   "court": 2,
   "wall": [
    "Closest game"
   ],
   "titles": [
    {
     "title": "Escape Artist",
     "line": "Let in 13 and still won, 15-13 in round 7",
     "where": "joint top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Steven & Mihir 11-4 with Paddy in round 13",
     "where": null
    }
   ],
   "nemesis": {
    "id": "krish",
    "lost": 2
   },
   "bestWin": {
    "round": 13,
    "court": 4
   }
  },
  "thujhan": {
   "name": "Thujhan",
   "photo": 3,
   "place": 7,
   "ranked": true,
   "games": 13,
   "wins": 7,
   "losses": 6,
   "pointsFor": 127,
   "pointsAgainst": 120,
   "avg": 9.77,
   "diff": 7,
   "bestRun": 2,
   "peopleMet": 24,
   "court": 2,
   "wall": [
    "Loudest heckler",
    "Closest game"
   ],
   "titles": [
    {
     "title": "Gallant in Defeat",
     "line": "Scored 13 and still lost, 13-15 in round 7",
     "where": "joint top on the day"
    },
    {
     "title": "Signature Win",
     "line": "Beat Shailen & Paddy 11-2 with Nayan in round 6",
     "where": null
    }
   ],
   "nemesis": {
    "id": "raul",
    "lost": 2
   },
   "bestWin": {
    "round": 6,
    "court": 4
   }
  },
  "yashvi": {
   "name": "Yashvi",
   "photo": 1,
   "place": 30,
   "ranked": true,
   "games": 13,
   "wins": 3,
   "losses": 10,
   "pointsFor": 95,
   "pointsAgainst": 133,
   "avg": 7.31,
   "diff": -38,
   "bestRun": 1,
   "peopleMet": 23,
   "court": 2,
   "wall": [],
   "titles": [
    {
     "title": "Moral Victories",
     "line": "59 points scored in defeat",
     "where": "3rd on the day, joint"
    },
    {
     "title": "Signature Win",
     "line": "Beat Simmi & Mayuran 11-4 with Riyan in round 7",
     "where": null
    }
   ],
   "nemesis": {
    "id": "barshan",
    "lost": 2
   },
   "bestWin": {
    "round": 7,
    "court": 2
   }
  }
 }
}
